import PackageForm from "features/LoyaltyPackage/presentation/pages/PackageForm";
import { PACKAGE_FORM_MODE } from "features/LoyaltyPackage/core/constants";
import React from "react";

function PackageCreatePage() {
  return <PackageForm mode={PACKAGE_FORM_MODE.CREATE} />;
}

export default PackageCreatePage;
